
import Nav from "@/components/Nav";
import Dlist from "@/components/Dlist";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: "Popularactivities",
components: { Nav, Dlist, Tab, TabItem },

data() {
return {
actives: 1, //选中标题样式用  1,2
list:[],
limit: 4,       page: 1, //预告用
total: 0, //预告用

nopage: 1, //回顾用
nototal: 0, //回顾用
showlog: false,
tabList:[
{
title:'活动预告',
id:1
},
{
title:'活动回顾',
id:2
}
],
tabIndex:1,
isLoading:false,//是否正在加载数据
};
},
methods: {

changeTab(id) {
this.tabIndex = id;
this.page=1;
this.list=[];
this.getData();
},
getData() {
this.$api
.gethotdata({
params: {
limit: this.limit,
category_id: 4,
type: this.tabIndex,
page: this.page
}
})
.then(res => {
if(res.data.success&&res.data.code==0){
this.list = this.list.concat(res.data.data.items);
this.total = res.data.data.total;
this.showlog = false;
this.isLoading = false;
}else{
this.$vux.toast.text(res.data.message, "middle");
}

});
},
scrool() {
let that = this;
var scrollTop = this.$refs.popContent.scrollTop;
var clientHeight = this.$refs.popContent.clientHeight;
var scrollHeight = this.$refs.popContent.scrollHeight;
if (scrollTop + clientHeight + 100 >= scrollHeight) {
if (that.limit * that.page < that.total && !that.isLoading) {
console.log("我触发了==>")
that.page++;
that.showlog = true;
that.isLoading = true
setTimeout(function() {
that.getData();
}, 1500);
}
}
}
},
created() {
this.getData();
},
mounted() {
this.$refs.popContent.addEventListener("scroll", this.scrool);
}
};



// WEBPACK FOOTER //
// ./src/pages/Popularactivities/popularactivities.vue